//
// ExportRequests.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./ExportFileFormat";
import "./ExportNumberFormat";
import "./ExportRequest";

var ExportRequests = createModule("BIRD::ExportRequests", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        numberFormat: 4,
        exportRequests: [1],
        fileFormat: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ExportRequests;
